import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_INQUIRY_ENAMAD = "getInquiryEnamad"; 

//mutation types
export const SET_INQUIRY_ENAMAD = "getInquiryEnamad";

export default {
    state: {
        
        resultInquiry:null,
        
    },
    getters: {
        /**
         * loade list of Gateway
         * @param state
         * @returns {*}
         */
        loadedResultInquiry(state) {
            return state.resultInquiry;
        },
    },
    actions: {
       
        
        /**
         * Set the create listCheckout
         * @param state
         * @param payload
         */
         [GET_INQUIRY_ENAMAD](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .getData('inquiry-domain/'+payload)
                .then((response) => {
                    context.commit(SET_INQUIRY_ENAMAD,response.result)
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
    },
    mutations: {
       
        [SET_INQUIRY_ENAMAD](state, payload) {
            state.resultInquiry = payload
        }
    }
};